import { Check, ChevronsUpDown } from "lucide-react";
import { useState } from "react";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "@/components/ui/command";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";

export function BranchSwitcher() {
    const { branches, currentBranchId, switchBranch } = useAuth();
    const [open, setOpen] = useState(false);
    const current = branches.find((b) => b.id === currentBranchId) || branches[0];
    if (!branches || branches.length === 0) return null;

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    data-testid="branch-switcher-button"
                    className="h-9 justify-between gap-2 border-zinc-200 bg-white px-3 font-medium dark:border-zinc-800 dark:bg-zinc-900"
                >
                    <span className="flex items-center gap-2">
                        <span className="hidden text-[10px] font-semibold uppercase tracking-wider text-zinc-500 sm:inline">
                            Branch
                        </span>
                        <span className="font-mono text-xs uppercase text-brand-redDeep dark:text-brand-red">
                            {current?.code || "—"}
                        </span>
                        <span className="hidden text-sm text-zinc-700 dark:text-zinc-300 md:inline">
                            {current?.name}
                        </span>
                    </span>
                    <ChevronsUpDown className="h-3.5 w-3.5 text-zinc-400" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-72 p-0" align="end">
                <Command>
                    <CommandInput placeholder="Search branches…" />
                    <CommandList>
                        <CommandEmpty>No branch found.</CommandEmpty>
                        <CommandGroup>
                            {branches.map((b) => (
                                <CommandItem
                                    key={b.id}
                                    value={`${b.code} ${b.name}`}
                                    data-testid={`branch-option-${b.code}`}
                                    onSelect={() => {
                                        switchBranch(b.id);
                                        setOpen(false);
                                    }}
                                    className="flex items-center gap-2"
                                >
                                    <Check
                                        className={cn(
                                            "h-4 w-4",
                                            b.id === currentBranchId ? "opacity-100 text-brand-red" : "opacity-0"
                                        )}
                                    />
                                    <span className="font-mono text-xs uppercase text-brand-redDeep dark:text-brand-red">
                                        {b.code}
                                    </span>
                                    <span className="truncate text-sm">{b.name}</span>
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
